<!--立项销售-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dynamicSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$router.push('project-sell/form')">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
      <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-view" @click="edit(scope.row)"></el-button>
          <el-button type="text" v-if="statusEdit(scope.row.billState)" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" v-if="statusEdit(scope.row.billState)" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
           <!-- <el-button type="text" size="mini">生成报价</el-button>
           <el-button type="text" size="mini">生成合同</el-button> -->
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { delSellProjects } from "@/api/basic";
import {tableSataus} from '@/views/bill/mixins/status'

export default {
  name: "ProjectSell",
  mixins: [DataTableMixin,tableSataus],
  components: {
    DynamicSearch
  },
  data() {
    return {
      tableHead: [
        {
          label: "项目名",
          prop: "projectName",
          query: {
            type: "input"
          },
          align: "left"
        },
        {
          label: "项目负责人",
          prop: "leader"
        },
         {
          label: "费用预算",
          prop: "costBudget"
        },
         {
          label: "费用预算耗费",
          prop: "costBudgetCost"
        },
         {
          label: "经营人",
          prop: "business.name"
        },
        {
          label: "计划成单日期",
          prop: "planDate",
        },
         {
          label: "状态",
          prop: "billState",
           formatter: (state) => {
              return this.statusName(state)
            }
        }
      ],
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/sellProject";
      const params = { page: this.page, size: this.offset};
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch() {
    },
    edit(row) {
      console.log(row);
      this.$router.push("project-sell/form?id=" + row.id);
    },
    // 删除
    subDelete(id) {
      console.log(id);
      delSellProjects(id).then(res => {
        console.log(res);
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
